// import '../styles/main.scss';
import 'foundation-sites/dist/js/foundation.js'; // this works

// import './helpers/polyfills';
import { videoController } from './modules/video';

class App {
  constructor() {
	$(document).foundation();
    videoController.init();
  }
}

export const app = new App();



// WEBPACK FOOTER //
// ./scripts/main.js